export default __webpack_public_path__ + "static/custom-domain-6f651f6ff0af7410f8cea0f16d7bc002.jpg";